import { IRepository } from "@karma-games/angular-devkit/src/lib/interfaces";
import { IUser } from "@karma-games/angular-devkit/src/lib/modules/user";
import { IAutoplayOptions, IUserBet } from "./store/interfaces";
import { DomainErrorType } from "@karma-games/angular-devkit/src/lib/classes/errors";

export interface IRoundRepository extends IRepository<IRound | undefined> {
}

export interface IRound {
    roundId: string | undefined;
    state: ERoundState;
    bets: IRoundBet[];
    multiplier: number;
    userBets: IUserBet[];
    autoplayOptions: IAutoplayOptions[];
}

export enum ERoundState {
    Idle = "idle",
    Playing = "playing",
    Ended = "ended"
}

export enum EBetSplit {
    FirstHalf = "firstHalf",
    SecondHalf = "secondHalf",
    Full = "full"
}

export interface IRoundBet {
    id: string;
    user?: IUser;
    date?: number;
    bet?: number;
    multiplier?: number | undefined;
    cashout?: number | undefined;
    totalAmount?: number | undefined;
    split?: EBetSplit;
}

export interface IRoundBetAccepted {
    roundId: string;
    amount: number;
    autoStop: number;
    betIndex: number;
    currency: string | undefined;
    player: {
        avatar: string;
        currency: string | undefined;
        id: string;
        name: string;
    };
}

export interface IRoundBetFailed {
    data: IRoundBetAccepted;
    error: DomainErrorType | { code: number; message: string };
}

export interface IRoundCashOutFailed {
    data: IRoundCashOut;
    error: DomainErrorType | { code: number; message: string };
}

export interface IRoundBetsAcceptedPayload {
    payload: {
        bets: IRoundBetAccepted[];
        totalBets: number;
    },
    roundId: string;
}

export interface IRoundBetCanceled {
    playerId: string;
    betIndex: number;
}

export interface IRoundBetsCanceledPayload {
    payload: {
        bets: IRoundBetCanceled[];
        totalBets: number;
    },
    roundId: string;
}

export interface IRoundProgressPayload {
    multiplier: number;
    payouts: IRoundPayout[];
}

export interface IRoundPayout {
    playerId: string;
    currency: string;
    amount: number;
    multiplierValue: number;
    betIndex: number;
    split: EBetSplit;
    totalAmount: number | undefined;
}

export interface IRoundEndPayload {
    payload: {
        multiplier: number;
        payouts: IRoundPayout[];
    },
    roundId: string;
}

export interface IRoundCashOut {
    roundId: string;
    playerId: string;
    currency: string;
    amount: number;
    totalAmount: number | undefined;
    multiplierValue: number;
    betIndex: number;
    split: EBetSplit;
}

export interface IBetActionResponse<T = TBetActionResponse> {
    response: T;
    successful: boolean;
}

export type TBetActionResponse = IRoundBetAccepted | IRoundBetCanceled | IRoundCashOut | IRoundBetFailed;

export interface IRoundGetStateData {
    nextRoundStartsAt: number;
    roundId: string | undefined;
    bets: {
        betIndex: number;
        amount: number;
        currency: string;
        autoStopMultiplier: number;
    }[];
    betsAccepted: IRoundBetAccepted[];
    payouts: IRoundPayout[];
    totalBets: number;
    balance: number;
}

export interface IRoundInitialState {
    userBets: IUserBet[];
    bets: IRoundBet[];
    roundId: string | undefined;
    initialRoundState: IRoundGetStateData;
    totalBets: number;
}
